export default [
    // *===============================================---*
    // *--------- USER ---- ---------------------------------------*
    // *===============================================---*
    {
        path: '/account',
        name: 'apps-users-edit',
        component: () => import('@/views/company/user/users-edit/UsersEdit.vue'),
        meta: {
            pageTitle: 'Account',
            breadcrumb: [
                {
                  text: 'Company',
                },
                {
                  text: 'My account',
                  active: true,
                },
              ],
        }
    },
    {
        path: '/workspace',
        name: 'workspace',
        component: () => import('@/views/pages/authentication/Workspace.vue'),
        meta: {
            layout: 'full',
            pageTitle: 'Workspace',
            resource: 'Workspace',
            action: 'read',
        }
    },
]